module.exports = __webpack_public_path__ + "img/refresh.12541d73.svg";